module.exports = __webpack_public_path__ + "static/media/智慧社区验收标准.250dde68.docx";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xieyi/智慧社区验收标准.docx
// module id = 548
// module chunks = 0